import { React, useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  PDFViewer,
  Font,
  Canvas,
  Link,
} from "@react-pdf/renderer";
import FigtreeRegular from "../../fonts/static/Figtree-Regular.ttf";
import FigtreeBold from "../../fonts/static/Figtree-Bold.ttf";
import { ToWords } from "to-words";


let company_code_from_local_storage = localStorage.getItem("companyCode")
  ? localStorage.getItem("companyCode")
  : "-";

const toWords = new ToWords({
  localeCode: "en-AE",
});

//Register additional font weights (optional)
Font.register({
  family: "Figtree",
  format: "truetype",
  fonts: [
    { src: FigtreeRegular, fontWeight: "normal" },
    { src: FigtreeBold, fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Figtree",
    paddingBottom: 180,
    paddingTop: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#dedede",
  },
  headerText: { fontSize: 12, fontWeight: "bold" },
  quotationTitleText: { fontSize: 12, fontWeight: "bold", paddingBottom: 10 },
  projectTitleText: {
    fontSize: 12,
    fontWeight: "bold",
    paddingBottom: 4,
    paddingTop: 6,
  },
  logo: { width: 110, height: 80 },
  header_image: { width: "100%" },
  header_image_sunrise: { width: "100%", marginHorizontal: -8 },
  prodImage: { width: 40, height: 40 },
  prodImage_No_image: { width: 20, height: 20 },
  sectionAbove: { marginTop: 4 },
  section: { marginBottom: 10, paddingTop: 10 },
  paddingBottom: { paddingBottom: 10 },
  seperator: { borderTopWidth: 1 },
  tableContainer: {
    flexDirection: "column",
    minHeight: "100", // Adjust this value based on your needs
    // maxHeight: 'auto', // Adjust this value based on your needs
    overflow: "hidden",
  },
  table: {
    marginTop: 10,
    width: "100%",
    borderLeftWidth: 0.5,
    borderTopWidth: 0.5,
    borderLeftColor: "#000000",
    borderTopColor: "#000000",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableRowBody: {
    flexDirection: "row",
  },
  tableHeader: {
    backgroundColor: "#cfcfd1",
  },

  tableCellValueInTablehead: {
    flex: 1.6,
    padding: 5,
    textAlign: "center",
    borderBottomWidth: 0.5,
    borderBottomColor: "#000000",
  },

  tableCell: {
    flex: 1,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },
  tableCellUnit: {
    flex: 0.5,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },
  tableCellUnitPrice: {
    flex: 1.6,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },
  tableCell_SN: {
    flex: 0.5,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },

  tableCellReftypeHeading: {
    flex: 1.4,
    paddingVertical: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },
  tableCellReftype: {
    flex: 1.4,
    paddingVertical: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellBody: {
    flex: 1,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellBodyUnit: {
    flex: 0.5,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellBodyUnitPrice: {
    flex: 1.6,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellBody_SN: {
    flex: 0.5,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellBodyAmount: {
    flex: 1.6,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellProductImage: {
    flex: 2, // Increased flex value for more width
    paddingTop: 5,
    paddingHorizontal: 2,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },
  tableCellProductImageBody: {
    flex: 2, // Increased flex value for more width
    paddingTop: 5,
    paddingHorizontal: 2,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },
  tableCellArticle: {
    flex: 1.9, // Increased flex value for more width
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },

  tableCellArticleBody: {
    flex: 1.9,
    padding: 5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
    overflowWrap: "break-word",
    hyphens: "manual",
  },

  tableWideCellHeading: {
    flex: 5,
    padding: 5,
    textAlign: "center",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#000000",
    borderBottomColor: "#000000",
  },

  tableWideCellView: {
    flex: 5,
    padding: 5,
    flexDirection: "column",
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightColor: "#cfcfd1",
    borderBottomColor: "#cfcfd1",
  },

  tableWideCell: {
    flex: 3,
    padding: 5,
    textAlign: "left",
  },
  summary: {
    textAlign: "right",
  },
  footer: { marginTop: 20, fontSize: 10, borderTopWidth: 1, paddingTop: 5 },
  pageNumber: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
  },
  descriptionText: {
    fontSize: 9,
  },
  watermarkText: {
    color: "#00000040",
    fontSize: 50,
    zIndex: 100,
  },
});

const manipulateTextToMakenewLine = (stringReceived) => {
  let n = 10; // insert a character after every 5 characters
  let insertChar = "\n";
  let outputString = stringReceived?.split("").reduce(function (acc, val, i) {
    return i % n === 0 && i !== 0 ? acc + insertChar + val : acc + val;
  }, "");

  return outputString;
};

const splitText = (stringReceived) => {
  console.log("stringReceived ", stringReceived);

  let n = 10; // insert a character after every 5 characters
  let insertChar = "\n";
  let outputString = stringReceived.split(",");

  return outputString;
};

const arrangeSalesPersonNameArray = (arrayToBeOrdered) => {
  console.log("arrayToBeOrdered ", arrayToBeOrdered);

  let newArray = arrayToBeOrdered.map((textToBeEdited) => {
    const trimmed = textToBeEdited.trim();

    if (trimmed.includes("@")) {
      return "Email : " + trimmed;
    } else if (/^[\d\s\-\+\(\)]+$/.test(trimmed)) {
      // ✅ handles numbers like "050- 000000", "+971 50 000000", "(050) 000000"
      return "Mob : " + trimmed;
    } else {
      return trimmed;
    }
  });

  let mobObject = newArray.filter((itemFilter) => {
    return itemFilter.includes("Mob");
  });

  let emailObject = newArray.filter((itemFilter) => {
    return itemFilter.includes("@");
  });

  let nameObject = newArray.filter((itemFilter) => {
    return !itemFilter.includes("@") && !itemFilter.includes("Mob");
  });

  console.log(
    "arrayToBeOrdered newArray mobObject",
    newArray,
    mobObject,
    emailObject
  );

  return [nameObject, mobObject, emailObject];
};

const QuotationPDF_2_cubix = ({
  selectedLead,
  formattedDate,
  leadProducts,
  productsInQuotationFromAPI,
  vatValue,
  alreadySentQuotationNumber,
  discountValue,
  salesOrderYesOrNo,
  preloadedImages,
}) => {
  console.log(
    "selectedLead in pdf_2: productsInQuotationFromAPI >>",
    selectedLead,
    productsInQuotationFromAPI
  );

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  console.log("Api paths Header ", apiPaths_from_local_storage[0].REP_HEADER);

  const filteredProducts = productsInQuotationFromAPI?.filter(
    (item) => item.itemCustRef !== "OPT" && item.itemCustRef !== "OPTION"
  ) || [];
  const grossTotal = filteredProducts.reduce((acc, curr) => acc + curr.itemQuantity * curr.itemPrice, 0);
  const discount = discountValue || 0;
  const taxableAmount = grossTotal - discount;
  const vatRate = productsInQuotationFromAPI?.[0]?.dynamicVatFromAPI || 0;
  const vatAmount = (taxableAmount * vatRate) / 100;
  const netValue = vatValue > 0 ? taxableAmount + vatAmount : taxableAmount;
  const computedIsVatPresent = productsInQuotationFromAPI ? (vatValue > 0) : null;

  const [isVatpresent, setIsVatpresent] = useState(computedIsVatPresent);

  const [netValueState, setNetValueState] = useState(netValue);

  useEffect(() => {
    if (preloadedImages !== undefined) return;
    console.log("Quotation pdf values vatValue ", vatValue, discountValue);

    if (productsInQuotationFromAPI) {
      if (vatValue > 0) {
        console.log("if vatPresent");
        setIsVatpresent(true);
      } else {
        console.log("else vatPresent");
        setIsVatpresent(false);
      }

      {
        vatValue > 0
          ? setNetValueState(
            productsInQuotationFromAPI
              ?.filter((item) => {
                if (
                  item.itemCustRef === "OPT" ||
                  item.itemCustRef === "OPTION"
                ) {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) -
            (discountValue ? discountValue : 0) +
            ((productsInQuotationFromAPI
              ?.filter((item) => {
                if (
                  item.itemCustRef === "OPT" ||
                  item.itemCustRef === "OPTION"
                ) {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) -
              (discountValue ? discountValue : 0)) *
              productsInQuotationFromAPI[0]?.dynamicVatFromAPI) /
            100
          )
          : setNetValueState(
            productsInQuotationFromAPI
              ?.filter((item) => {
                if (
                  item.itemCustRef === "OPT" ||
                  item.itemCustRef === "OPTION"
                ) {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) - (discountValue ? discountValue : 0)
          );
      }
    }
  }, [productsInQuotationFromAPI]);

  const [sunriseHeader, setSunriseHeader] = useState(preloadedImages?.header ?? null);
  const [sunriseFooter, setSunriseFooter] = useState(preloadedImages?.footer ?? null);

  // 1. Get and Normalize Company Code
  const rawCompanyCode = localStorage.getItem("companyCode") || "-";
  const normalizedCode = rawCompanyCode.trim().toUpperCase();
  // Added a loading state to track image acquisition progress
  const [isLoadingImages, setIsLoadingImages] = useState(preloadedImages !== undefined ? false : true);

  // useEffect(() => {
  //   // 2. Exact match check with Uppercase normalization
  //   if (normalizedCode === "SUNRISEWEB" || normalizedCode === "SUNRISEDXB") {

  //     setIsLoadingImages(true);

  //     fetch("/data/sunrisedxb_header.txt")
  //       .then((res) => res.text())
  //       .then((data) => {
  //         // Add data URI prefix if it's missing in the text file
  //         const formatted = data.startsWith("data:image")
  //           ? data
  //           : `data:image/png;base64,${data}`;
  //         setSunriseHeader(formatted);
  //       })
  //       .catch((err) => console.error("Error loading Sunrise header:", err));

  //       fetch("/data/sunrisedxb_footer.txt")
  //       .then((res) => res.text())
  //       .then((data) => {
  //         // Add data URI prefix if it's missing in the text file
  //         const formattedFooter = data.startsWith("data:image")
  //           ? data
  //           : `data:image/png;base64,${data}`;
  //         setSunriseFooter(formattedFooter);
  //       })
  //       .catch((err) => console.error("Error loading Sunrise footer:", err));
  //   }
  // }, [normalizedCode]);

  useEffect(() => {
    if (preloadedImages !== undefined) return;
    if (normalizedCode === "SUNRISEWEB" || normalizedCode === "SUNRISEDXB") {
      setIsLoadingImages(true);

      // Load both text files simultaneously using Promise.all
      Promise.all([
        fetch("/data/sunrisedxb_header.txt").then((res) => res.text()),
        fetch("/data/sunrisedxb_footer.txt").then((res) => res.text())
      ])
        .then(([headerData, footerData]) => {
          const formattedHeader = headerData.startsWith("data:image")
            ? headerData
            : `data:image/png;base64,${headerData}`;

          const formattedFooter = footerData.startsWith("data:image")
            ? footerData
            : `data:image/png;base64,${footerData}`;

          setSunriseHeader(formattedHeader);
          setSunriseFooter(formattedFooter);
          setIsLoadingImages(false);
        })
        .catch((err) => {
          console.error("Error loading Sunrise components:", err);
          setIsLoadingImages(false);
        });
    } else {
      // If company code doesn't require fetching asset documents, stop loading immediately
      setIsLoadingImages(false);
    }
  }, [normalizedCode]);

  // Safeguard rule: Do not load the react-pdf structure while async files are resolving
  if (isLoadingImages) {
    return <View><Text style={{ padding: 20 }}>Loading Document Layout Assets...</Text></View>;
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {(productsInQuotationFromAPI[0]?.area_code === "Draft" ||
          productsInQuotationFromAPI[0]?.area_code === "For Approval") && (
            <Text
              style={{
                position: "absolute",
                top: "40%",
                left: "30%",
                ...styles.watermarkText,
              }}
              fixed
            >
              Draft Copy
            </Text>
          )}

        {/* Header */}
        <View style={styles.header} fixed>
          <View style={{ width: "100%" }}>
            <View style={{ width: "100%" }}>
              {/* {sunriseHeader ? (
                <Image
                  src={sunriseHeader}
                  style={
                    sunriseHeader
                      ? styles.header_image_sunrise
                      : styles.header_image
                  }
                />
              ) : apiPaths_from_local_storage[0]?.REP_HEADER?.includes(
                "data:image/"
              ) ? ( */}
              <Image
                src={apiPaths_from_local_storage[0].REP_HEADER}
                style={styles.header_image}
              />
              {/* ) : null} */}
            </View>

            {/* <Text style={styles.headerText}>{apiPaths_from_local_storage[0].COMPNAME} </Text> */}

            {/* {company_code_from_local_storage === "SUNRISEDXB" && productsInQuotationFromAPI[0].salespersonName ? (
              <View style={{ marginTop: sunriseHeader ? -50 : 0 }}>
                <Text style={{ marginTop: 8, fontSize: 10 }}>Contact</Text>

                <View style={{ flexDirection: "column", marginTop: 4 }}>
                  {arrangeSalesPersonNameArray(
                    splitText(productsInQuotationFromAPI[0].salespersonName)
                  )?.map((item, index) => (
                    <Text
                      key={index}
                      style={{ fontWeight: "bold", marginRight: 4 }}
                    >
                      {item}
                    </Text>
                  ))}
                </View>
              </View>
            ) : null} */}
          </View>
        </View>

        {/* Customer & Project Details */}

        <View style={styles.section}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <View style={{ width: "50%" }}>
              {salesOrderYesOrNo?.isthisSalesOrder ? (
                <Text style={styles.quotationTitleText}>Sales Order</Text>
              ) : (
                <Text style={styles.quotationTitleText}>Quotation</Text>
              )}
              <Text>To:</Text>

              <Text style={{ fontWeight: "bold" }}>
                {productsInQuotationFromAPI[0].customer_name_from_details?.toUpperCase()}
              </Text>

              <Text>Attn: {productsInQuotationFromAPI[0].head1}</Text>

              {/* <Text style={{ wrap: "w" }}>
                {productsInQuotationFromAPI[0].Address}
              </Text> */}

              {/* <Text>
                {productsInQuotationFromAPI[0].Lead_email
                  ? productsInQuotationFromAPI[0].Lead_email
                  : selectedLead.lead_email
                  ? selectedLead.lead_email
                  : ""}{" "}
                |{" "}
                {productsInQuotationFromAPI[0].Lead_Phone
                  ? productsInQuotationFromAPI[0].Lead_Phone
                  : selectedLead.lead_phone
                  ? selectedLead.lead_phone
                  : ""}
              </Text> */}
              <Text>
                {productsInQuotationFromAPI[0].Lead_email
                  ? productsInQuotationFromAPI[0].Lead_email
                  : ""}{" "}
                |
                {productsInQuotationFromAPI[0].Lead_Phone
                  ? productsInQuotationFromAPI[0].Lead_Phone
                  : ""}
              </Text>

            </View>
            <View>
              <View style={{ marginTop: "auto", marginRight: "20%" }}>
                <Text>
                  Quot. No. :{" "}
                  {productsInQuotationFromAPI[0]?.quotation_number}
                </Text>
                {/* {selectedLead.Salesorder_No
                  ? null
                  : productsInQuotationFromAPI[0]?.revision_number && (
                    <Text style={styles.sectionAbove}>
                      Rev. No. :{" "}
                      {productsInQuotationFromAPI[0]?.revision_number}
                    </Text>
                  )} */}

                <Text style={styles.sectionAbove}>Date: {formattedDate}</Text>
                {/* <Text style={styles.sectionAbove}>Sales Person: {productsInQuotationFromAPI[0]?.Sales_Person}</Text> */}
              </View>
              {productsInQuotationFromAPI[0]?.project_name_from_details && (
                <View style={{ marginTop: "auto", marginRight: "20%" }}>
                  <Text style={styles.projectTitleText}>Project</Text>
                  <Text>
                    {productsInQuotationFromAPI?.length > 0
                      ? productsInQuotationFromAPI[0]?.project_name_from_details
                      : ""}
                  </Text>
                </View>
              )}
            </View>
          </View>
        </View>

        {/* Products Table */}

        {/* Products Table */}
        <View style={styles.tableContainer}>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={[styles.tableCell_SN, styles.descriptionText]}>
                S.N
              </Text>
              {company_code_from_local_storage?.trim().toUpperCase() !=
                "CUBIX" && (
                  <>
                    {/* <Text
                      style={[
                        styles.tableCellReftypeHeading,
                        styles.descriptionText,
                      ]}
                    >
                      Ref/Type
                    </Text> */}
                    <Text
                      style={[styles.tableCellArticle, styles.descriptionText]}
                    >
                      Code
                    </Text>
                  </>
                )}

              <Text
                style={[styles.tableWideCellHeading, styles.descriptionText]}
              >
                Descriptions
              </Text>
              {company_code_from_local_storage?.trim().toUpperCase() !=
                "CUBIX" && (
                  <Text
                    style={[styles.tableCellProductImage, styles.descriptionText]}
                  >
                    Product Image
                  </Text>
                )}

              <Text style={[styles.tableCellUnit, styles.descriptionText]}>
                Unit
              </Text>
              <Text style={[styles.tableCell, styles.descriptionText]}>
                Qty
              </Text>
              <Text style={[styles.tableCellUnitPrice, styles.descriptionText]}>
                Unit Price
              </Text>
              <Text
                style={[
                  styles.tableCellValueInTablehead,
                  styles.descriptionText,
                ]}
              >
                Value
              </Text>
            </View>
            {productsInQuotationFromAPI?.map((item, index) => (
              <View style={styles.tableRowBody} key={index} wrap={false}>
                <Text style={[styles.tableCellBody_SN, styles.descriptionText]}>
                  {index + 1}
                </Text>

                {company_code_from_local_storage?.trim().toUpperCase() !=
                  "CUBIX" && (
                    <>
                      {/* <Text
                        style={[styles.tableCellReftype, styles.descriptionText]}
                      >
                        {item.itemCustRef}
                      </Text> */}
                      <View
                        style={[
                          styles.tableCellArticleBody,
                          styles.descriptionText,
                        ]}
                      >
                        <Text>
                          {manipulateTextToMakenewLine(item.itemCode) || "--"}
                        </Text>
                      </View>
                    </>
                  )}

                <View
                  style={[styles.tableWideCellView, styles.descriptionText]}
                >
                  <Text style={styles.descriptionText}>
                    {item.itemDescription}
                  </Text>
                  <View>
                    <Link target={"blank"} src={item.itemWebLink}>
                      {item.itemWebLink}
                    </Link>
                  </View>
                </View>

                {company_code_from_local_storage?.trim().toUpperCase() !=
                  "CUBIX" && (
                    <Text style={styles.tableCellProductImageBody}>
                      {item.itemImageBase64 ? (
                        item.itemImageBase64 === "" ? (
                          <View></View>
                        ) : item.itemImageBase64.includes("data:image/") ? (
                          <Image
                            src={item.itemImageBase64}
                            style={styles.prodImage}
                          />
                        ) : (
                          <View></View>
                        )
                      ) : (
                        <View></View>
                      )}
                    </Text>
                  )}

                <Text style={[styles.tableCellBodyUnit, styles.descriptionText]}>
                  {item.itemUnit || "--"}
                </Text>
                <Text style={[styles.tableCellBody, styles.descriptionText]}>
                  {item.itemQuantity || "--"}
                </Text>
                <Text style={[styles.tableCellBodyUnitPrice, styles.descriptionText]}>
                  {item.itemFoc === "FOC"
                    ? 0
                    : parseFloat(item.itemPrice).toFixed(2)}
                </Text>
                <Text style={[styles.tableCellBodyAmount, styles.descriptionText]}>
                  {item.itemFoc === "FOC"
                    ? 0
                    : item.itemCustRef === "OPT" || item.itemCustRef === "OPTION"
                      ? ""
                      : parseFloat(item.itemAmount).toFixed(2)}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* Pricing Summary */}

        <View
          wrap={false}
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <View style={{ width: "50%" }}>
            <Text style={{ marginTop: "auto" }}>Net Value in Words</Text>
            {netValueState && (
              <Text>
                {productsInQuotationFromAPI[0]?.fc + " : "}
                {toWords.convert(parseInt(netValueState))}{" "}
                {(netValueState - Math.floor(netValueState)).toFixed(2) *
                  100 ? (
                  <Text>
                    AND{" "}
                    {parseInt(
                      (netValueState - Math.floor(netValueState)).toFixed(2) *
                      100
                    )}{" "}
                    / 100 ONLY
                  </Text>
                ) : (
                  <Text>ONLY</Text>
                )}
              </Text>
            )}
          </View>
          <View style={[{ fontWeight: "bold", width: "35%" }]}>
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Text>Total Value: </Text>
              <Text>
                {productsInQuotationFromAPI
                  ?.filter((item) => {
                    if (
                      item.itemCustRef === "OPT" ||
                      item.itemCustRef === "OPTION"
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                  .reduce((acc, curr) => {
                    return acc + curr.itemQuantity * curr.itemPrice;
                  }, 0)
                  .toFixed(2)}
              </Text>
            </View>

            {discountValue && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 4,
                }}
              >
                <Text>Special Discount: </Text>
                <Text>{discountValue}</Text>
              </View>
            )}

            {discountValue && (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 4,
                }}
              >
                <Text>Price After Discount:</Text>
                <Text>
                  {parseFloat(
                    productsInQuotationFromAPI
                      ?.filter((item) => {
                        if (
                          item.itemCustRef === "OPT" ||
                          item.itemCustRef === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }, 0) - (discountValue ? discountValue : 0)
                  ).toFixed(2)}
                </Text>
              </View>
            )}

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 4,
              }}
            >
              {isVatpresent && (
                <Text>
                  VAT {productsInQuotationFromAPI[0]?.dynamicVatFromAPI}%:{" "}
                </Text>
              )}
              {isVatpresent && (
                <Text>
                  {isVatpresent
                    ? parseFloat(
                      ((productsInQuotationFromAPI
                        ?.filter((item) => {
                          if (
                            item.itemCustRef === "OPT" ||
                            item.itemCustRef === "OPTION"
                          ) {
                            return false;
                          } else {
                            return true;
                          }
                        })
                        .reduce((acc, curr) => {
                          return acc + curr.itemQuantity * curr.itemPrice;
                        }, 0) -
                        (discountValue ? discountValue : 0)) *
                        productsInQuotationFromAPI[0]?.dynamicVatFromAPI) /
                      100
                    ).toFixed(2)
                    : 0}
                </Text>
              )}
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 4,
              }}
            >
              <Text>Net Value: </Text>
              <Text>
                {isVatpresent
                  ? (
                    productsInQuotationFromAPI
                      ?.filter((item) => {
                        if (
                          item.itemCustRef === "OPT" ||
                          item.itemCustRef === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }, 0) -
                    (discountValue ? discountValue : 0) +
                    ((productsInQuotationFromAPI
                      ?.filter((item) => {
                        if (
                          item.itemCustRef === "OPT" ||
                          item.itemCustRef === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }, 0) -
                      (discountValue ? discountValue : 0)) *
                      productsInQuotationFromAPI[0]?.dynamicVatFromAPI) /
                    100
                  ).toFixed(2)
                  : (
                    productsInQuotationFromAPI
                      ?.filter((item) => {
                        if (
                          item.itemCustRef === "OPT" ||
                          item.itemCustRef === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }, 0) - (discountValue ? discountValue : 0)
                  ).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        <View wrap={false}>
          {/* Terms & Conditions */}
          <View style={styles.footer}>
            <Text style={styles.headerText}>Terms & Conditions:</Text>

            <Text style={{ marginTop: 4 }}>
              {productsInQuotationFromAPI[0]?.payment}
            </Text>
          </View>

          <View style={[styles.section, { borderTopWidth: 1 }]}>
            <Text style={styles.headerText}>Prepared by:</Text>
            {console.log(
              "selectedLead pro array >> prep ",
              selectedLead,
              productsInQuotationFromAPI
            )}

            {productsInQuotationFromAPI[0].Coordinator?.trim() != "" &&
              productsInQuotationFromAPI[0].Coordinator?.trim() != "-" &&
              productsInQuotationFromAPI[0].lead_CoordinatorName != null // confirmed only blank will come else value
              ? productsInQuotationFromAPI[0].lead_CoordinatorName &&
              arrangeSalesPersonNameArray(
                splitText(productsInQuotationFromAPI[0].lead_CoordinatorName)
              )?.map((item) => {
                return <Text>{item}</Text>;
              })
              : // <Text>1st</Text>

              // <Text>2nds</Text>
              productsInQuotationFromAPI[0].salespersonName &&
              arrangeSalesPersonNameArray(
                splitText(productsInQuotationFromAPI[0].salespersonName)
              )?.map((item) => {
                return <Text>{item}</Text>;
              })}
          </View>
        </View>

        <View style={styles.pageNumber} fixed>
          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />

          {/* {sunriseFooter ? (
            <Image
              src={sunriseFooter}
              style={
                styles.header_image
              }
            />
          ) : apiPaths_from_local_storage[0]?.REP_FOOTER?.includes(
            "data:image/"
          ) ? ( */}
          <Image
            style={{ paddingHorizontal: 8 }}
            src={apiPaths_from_local_storage[0].REP_FOOTER}
          />
          {/* ) : null} */}
        </View>
      </Page>
    </Document>
  );
};

export default QuotationPDF_2_cubix;
